<template>
  <router-link :to="{ name: 'Catalog', query: { filters: [], categories: `${category.id}`  }}" class="card flx">
    <img v-if="category.image_url" style="object-fit:cover" :src="category.image_url" :alt="category.name">
    <img v-else style="object-fit:cover" src="/images/no-img.svg" alt="">
    <span>{{ category.name }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'CategoryCard',
  props: {
    category: {
      type: Object,
      default: () => {
        return {
          name: 'Толстовки и свитшоты',
          image: '/images/tolstovki-i-svitshoty.png',
          id: undefined
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
